//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, inject, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {of, Subscription, timer} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {ApiHealthService} from '../../../services/api-health.service';
import {UntilDestroy} from '@ngneat/until-destroy';
import {AuthService} from '../../../services/auth-service';
import authHelper from '../../auth/authHelper';
import {AppState} from '../../store/app.state';
import {Store} from '@ngrx/store';
import {loadUser} from '../../store/user/user.actions';
import {selectUser} from '../../store/user/user.selectors';
import { MatDialog } from '@angular/material/dialog';

@UntilDestroy({checkProperties: true})
@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss'],
    standalone: false
})
export class MaintenanceComponent implements OnInit {

  interval!: Subscription;
  private route = inject(ActivatedRoute);
  private apiHealthService = inject(ApiHealthService);
  private authService = inject(AuthService);
  private store = inject(Store<AppState>);
  private router = inject(Router);
  private dialog = inject(MatDialog);

  ngOnInit(): void {
    this.authService.maintenanceMode$.next(true);
    this.authService.showNav.next(false);
    this.authService.showToolbar.next(false);
    this.authService.showBanners.next(false);
    this.dialog.closeAll();
    this.interval = timer(0, 10000).pipe(
      switchMap(() => {
        return this.apiHealthService.checkHealth();
      }),
      switchMap(isOkay => {
        if (isOkay) {
          if (this.authService.isLoggedIn) {
            this.store.dispatch(loadUser());
            return this.store.select(selectUser());
          } else {
            this.router.navigateByUrl(this.route.snapshot.queryParams['redirect']);
            this.authService.showNav.next(true);
            this.authService.showToolbar.next(true);
            this.authService.showBanners.next(true);
            this.authService.maintenanceMode$.next(false);
          }
        }
        return of(null);
      })
    ).subscribe(user => {
      if(user) {
        // In the force two-factor flow, if the user refreshes after setting their 2FA, but before hitting the Done
        // button then they would stay logged in, but in a strange state of not being able to navigate around.
        // The auth token would still have the ftf claim set, but the user from the api would not have it set.
        // They must log back in.
        if (authHelper.getFeatureFlagFromToken('ftf') && !user.force_two_factor) {
          this.authService.logout();
        } else {
          this.router.navigateByUrl(this.route.snapshot.queryParams['redirect']);
          this.authService.showNav.next(true);
          this.authService.showToolbar.next(true);
          this.authService.showBanners.next(true);
          this.authService.maintenanceMode$.next(false);
        }
      }
    });
  }

}
